import { MARQUEE_ITEMS } from "../lib/content";

export const Marquee = () => (
  <div className="marquee" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div
          key={copy}
          aria-hidden={copy === 1}
          className="flex shrink-0 items-center"
        >
          {MARQUEE_ITEMS.map((item, i) => (
            <span
              key={i}
              className="flex items-center gap-8 whitespace-nowrap px-8 py-5 font-mono text-[0.78rem] font-semibold uppercase tracking-[0.2em] text-foreground/70"
            >
              {item}
              <span className="text-terra" aria-hidden="true">
                ✦
              </span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
